import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {Subscription} from "rxjs";
import {NavigationService} from "../../../services/navigation.service";
import {UserDto} from "@esa/api/models/UserDto";

@Component({
  selector: 'searchbar',
  templateUrl: './searchbar.component.html',
  styleUrls: ['./searchbar.component.scss'],
})
export class SearchbarComponent implements OnInit, OnDestroy {

  @Input() loggedInUser: UserDto;

  selectedItem: string = 'Dashboard';
  private activeView$: Subscription = new Subscription();


  constructor(
    private _translateService: TranslateService,
    private navigationService: NavigationService,
  ) {
  }

  ngOnInit() {
    this.activeView$ = this.navigationService.selectedItem$.subscribe((selectedItem: any) => {
      this.selectedItem = selectedItem;
      window.scroll(0,0);
    });
  }

  ngOnDestroy() {
    this.activeView$.unsubscribe();
  }

  changeLanguage(language: string) {
    this._translateService.use(language);
  }

  canCreateCase() {
    return !this.loggedInUser?.role?.roleName.toLowerCase().includes("admin");
  }

  canCreateUser() {
    return !this.loggedInUser?.role?.roleName.toLowerCase().includes("analyst");
  }

  canCreateFiu() {
    return this.loggedInUser?.role?.roleName.toLowerCase().includes("admin");
  }
}
